(function() {
  'use strict';

  /* ─────────────────────────────────────────────────────
     STATE
     ───────────────────────────────────────────────────── */
  var S = {
    size: null, cylinder: null, filter: null, hoseSize: null,
    reg: null, regP: 0, regVid: null, regImg: null, regUrl: null,
    diff: null, diffP: 0, diffVid: null, diffImg: null, diffUrl: null,
    hose: null, hoseP: 0, hoseVid: null, hoseImg: null, hoseUrl: null,
    extras: {}
  };
  var cur = 1;   /* Step 1 is active in HTML on load — keep JS in sync */
  var STEPS = 7;

  /* ─────────────────────────────────────────────────────
     DATA — customizer overrides + hardcoded defaults
     ───────────────────────────────────────────────────── */
  var D = window._CO2 || {};

  function mergeSlot(ov, def) {
    if (!ov) return def;
    return {
      id: def.id, vid: ov.vid, brand: ov.brand || def.brand,
      name: ov.name || def.name, variant: ov.variant || def.variant || null,
      img: ov.img || def.img || null,
      price: ov.price != null ? ov.price : def.price,
      why: ov.why || def.why, rec: ov.rec != null ? ov.rec : def.rec,
      url: ov.url || null, ssOnly: ov.ssOnly || false,
      avail: ov.avail != null ? ov.avail : true
    };
  }
  function mergeArr(ovArr, defArr) {
    if (!ovArr || !defArr) return defArr || ovArr || [];
    return defArr.map(function(d, i) { return mergeSlot(ovArr[i], d); });
  }

  /* ── Regulator defaults (flat — all regulators work for any tank size) ── */
  var DEF_REGS = [
    { id:'r1', vid:47463312392434, brand:'Wyin Aqua', name:'Mini Smart CO\u2082 Regulator', img:null, price:179.99, why:'Compact smart regulator with dual gauge and solenoid. Great entry-level option.', rec:false },
    { id:'r2', vid:46425073221874, brand:'Co2 Art', name:'PRO-SE Dual Stage Regulator', img:null, price:299.99, why:'True dual-stage with integrated solenoid. Our most popular regulator.', rec:true },
    { id:'r3', vid:47443340853490, brand:'Wyin Aqua', name:'Dual Stage Smart Modular Regulator', img:null, price:279.99, why:'Full dual-stage modular design with smart solenoid. Great value.', rec:false },
    { id:'r4', vid:46425073320178, brand:'Co2 Art', name:'PRO-ELITE v2 Dual Stage Regulator', img:null, price:559.99, why:'The most advanced aquarium CO\u2082 regulator available. Maximum precision.', rec:false }
  ];

  /* ── Inline diffuser defaults (canister + sump) — by hose diameter ── */
  var DEF_INLINE = {
    '12_16': [
      { id:'d1', vid:46425035145458, brand:'BSFH', name:'Inline CO\u2082 Atomizer \u2014 12/16mm', img:null, price:18.99, why:'Budget inline atomizer for 12/16mm hose. Hidden in your pipework for a clean look.', rec:false },
      { id:'d2', vid:47414286844146, brand:'Wyin Aqua', name:'External Inline CO\u2082 Diffuser \u2014 12/16mm', img:null, price:59.99, why:'Premium inline diffuser with replaceable ceramic membrane. Near 100% dissolution.', rec:true }
    ],
    '16_22': [
      { id:'d3', vid:47414286876914, brand:'Wyin Aqua', name:'External Inline CO\u2082 Diffuser \u2014 16/22mm', img:null, price:64.99, why:'High-flow inline diffuser for 16/22mm hose. Excellent dissolution rate.', rec:false },
      { id:'d4', vid:46943120359666, brand:'Co2 Art', name:'Inline CO\u2082 Diffuser \u2014 16/22mm', img:null, price:85.99, why:'Premium inline diffuser with the finest ceramic membrane on the market.', rec:true }
    ],
    '20_25': [
      { id:'d5', vid:47414286876914, brand:'Wyin Aqua', name:'External Inline CO\u2082 Diffuser \u2014 16/22mm', img:null, price:64.99, why:'High-flow inline diffuser. Use with a reducer fitting for 20/25mm hose.', rec:false },
      { id:'d6', vid:46943120359666, brand:'Co2 Art', name:'Inline CO\u2082 Diffuser \u2014 16/22mm', img:null, price:85.99, why:'Premium inline diffuser. Use with a reducer fitting for 20/25mm hose.', rec:true }
    ]
  };

  /* ── In-tank diffuser defaults (HOB / internal / sodastream) — by tank size ── */
  var DEF_INTANK = {
    nano: [
      { id:'d7', vid:47469992444146, brand:'BSFH', name:'Nano CO\u2082 Diffuser', img:null, price:15.99, why:'Compact diffuser. Suction-cup mount next to your filter outflow.', rec:false },
      { id:'d8', vid:46425031147762, brand:'Aquapro', name:'Neo CO\u2082 Diffuser \u2014 Tiny', img:null, price:20.99, why:'Premium nano glass diffuser producing noticeably finer mist.', rec:true }
    ],
    medium: [
      { id:'d9', vid:46425031114994, brand:'Aquapro', name:'Neo CO\u2082 Diffuser \u2014 Small', img:null, price:21.99, why:'Quality glass diffuser sized for medium tanks. Position near the outflow.', rec:false },
      { id:'d10', vid:46425073516786, brand:'Co2 Art', name:'Bazooka Flux Diffuser \u2014 Small', img:null, price:54.99, why:'Premium ceramic disc with exceptional fine mist output.', rec:true }
    ],
    large: [
      { id:'d11', vid:46425031049458, brand:'Aquapro', name:'Neo CO\u2082 Diffuser \u2014 Large', img:null, price:27.99, why:'Budget-friendly large diffuser with solid output.', rec:false },
      { id:'d12', vid:46425073549554, brand:'Co2 Art', name:'Bazooka Flux Diffuser \u2014 Large', img:null, price:59.99, why:'High-output premium diffuser. Exceptional fine mist quality.', rec:true }
    ]
  };

  /* ── Hose defaults ── */
  var DEF_HOSE = [
    { id:'h1', vid:47977633251570, brand:'Aquapro', name:'CO\u2082 Tubing \u2014 3m', img:null, price:12.99, why:'Pressure-rated polyurethane tubing. 3 metres suits most setups.', rec:false },
    { id:'h2', vid:46942917656818, brand:'CO2 Art', name:'CO\u2082 Resistant Tubing \u2014 3m', img:null, price:14.99, why:'Premium CO\u2082-proof tubing. Zero gas bleed-through.', rec:true },
    { id:'h3', vid:46425073844466, brand:'CO2 Art', name:'CO\u2082 Resistant Tubing \u2014 6m', img:null, price:19.99, why:'Extra-long 6m run for larger setups or cabinets further from the tank.', rec:false }
  ];

  /* ── Extras defaults ── */
  var DEF_EXTRAS = [
    { id:'x1', vid:46425033703666, name:'Aquapro Drop Checker', img:null, price:16.99, desc:'Liquid colour-change indicator \u2014 lime green = perfect CO\u2082. Continuous, always-on monitoring.', badge:false },
    { id:'x2', vid:46942990991602, name:'CO2 Art Drop Checker Kit', img:null, price:37.99, desc:'Premium glass drop checker with solution included. Precise monitoring with premium build quality.', badge:false },
    { id:'x3', vid:46425031770354, name:'Stainless Steel Check Valve', img:null, price:12.99, desc:'Prevents water siphoning back into your regulator. Protects a $180\u2013560 regulator for under $13.', badge:true }
  ];

  /* ── Merge with customizer data ── */
  var sizes = ['nano','medium','large'];
  var hoseSizes = ['12_16','16_22','20_25'];

  var REGS = mergeArr(D.regs, DEF_REGS);

  var INLINE_DIFFS = {};
  hoseSizes.forEach(function(s) { INLINE_DIFFS[s] = mergeArr(D.inlineDiffs && D.inlineDiffs[s], DEF_INLINE[s]); });

  var INTANK_DIFFS = {};
  sizes.forEach(function(s) { INTANK_DIFFS[s] = mergeArr(D.intankDiffs && D.intankDiffs[s], DEF_INTANK[s]); });

  var HOSE = mergeArr(D.hose, DEF_HOSE);

  function mergeExtra(ov, def) {
    if (!ov) return def;
    return {
      id: def.id, vid: ov.vid, name: ov.name || def.name,
      variant: ov.variant || def.variant || null,
      img: ov.img || null, price: ov.price != null ? ov.price : def.price,
      desc: ov.desc || def.desc, badge: ov.badge != null ? ov.badge : def.badge,
      url: ov.url || null,
      avail: ov.avail != null ? ov.avail : true
    };
  }
  var EXTRAS = DEF_EXTRAS.map(function(d, i) {
    return mergeExtra(D.extras && D.extras[i], d);
  });

  /* Sodastream adapters — two types */
  var SS_ADAPTER_DEFAULT = D.ssAdapterDefault || null;
  var SS_ADAPTER_BRASS = D.ssAdapterBrass || null;
  var BRASS_REG_VID = 47463312392434;

  function getSSAdapter() {
    if (S.regVid === BRASS_REG_VID && SS_ADAPTER_BRASS) return SS_ADAPTER_BRASS;
    return SS_ADAPTER_DEFAULT;
  }

  /* Sodastream cylinder stand — optional recommendation */
  var SS_STAND = D.ssStand || null;

  /* Discount settings */
  var DISC = D.discount || { type: 'none', value: 0, label: 'Bundle Discount', code: '' };

  /* ── Label lookups ── */
  var SLBLS = { nano:'Nano / up to 60 L', medium:'Medium / 60\u2013150 L', large:'Large / 150 L+' };
  var FLBLS = { canister:'Canister Filter', hob:'Hang on Back', internal:'Internal Filter', sump:'Sump Filter' };
  var HSLBLS = { '12_16':'12/16mm', '16_22':'16/22mm', '20_25':'20/25mm' };
  var STEP_NAMES = ['', 'Tank Size', 'Cylinder', 'Filter Type', 'Regulator', 'Diffuser', 'Hose', 'Extras'];

  /* ─────────────────────────────────────────────────────
     DOM
     ───────────────────────────────────────────────────── */
  function $(id) { return document.getElementById(id); }

  /* ─────────────────────────────────────────────────────
     NAVIGATION
     ───────────────────────────────────────────────────── */
  function start() {
    goTo(1);
    setTimeout(function() {
      $('co2-ba').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function goTo(n) {
    document.querySelectorAll('.co2-bb .step').forEach(function(s) { s.classList.remove('active'); });
    $('co2-s' + n).classList.add('active');
    cur = n;

    var pct = ((n - 1) / STEPS) * 100;
    $('co2-pf').style.width = pct + '%';
    $('co2-pl').textContent = 'Step ' + n + ' of ' + STEPS;
    $('co2-pn').textContent = STEP_NAMES[n] || '';

    /* Step 3: Filter — dynamic subtitle based on cylinder type */
    if (n === 3) {
      var fsub = $('co2-fsub');
      if (fsub) {
        var fkey = S.cylinder === 'sodastream' ? 'sodastream' : 'standard';
        if (fsub.dataset[fkey]) fsub.textContent = fsub.dataset[fkey];
      }
    }

    /* Step 4: Regulator — flat list; hide ssOnly regulators for standard cylinder */
    if (n === 4) {
      $('co2-n4').disabled = true;
      var regsToShow = S.cylinder === 'sodastream' ? REGS : REGS.filter(function(r) { return !r.ssOnly; });
      buildProds('co2-rg', regsToShow, 'reg', 'co2-n4');
    }

    /* Step 5: Diffuser — depends on cylinder type and filter type */
    if (n === 5) {
      $('co2-n5').disabled = true;
      var dsub = $('co2-dsub');
      var picker = $('co2-hose-picker');

      if (S.cylinder === 'sodastream') {
        /* Sodastream = always in-tank (lower pressure, not suitable for inline atomisers) */
        if (picker) picker.style.display = 'none';
        S.hoseSize = null;
        if (dsub) dsub.textContent = dsub.dataset.sodastream || 'Sodastream cylinders run at lower pressure, so we recommend in-tank diffusers for reliable performance.';
        buildProds('co2-dg', INTANK_DIFFS[S.size] || INTANK_DIFFS.medium, 'diff', 'co2-n5');
      } else if (S.filter === 'canister' || S.filter === 'sump') {
        /* Show hose diameter picker for inline filters */
        if (picker) picker.style.display = '';
        if (dsub && dsub.dataset[S.filter]) dsub.textContent = dsub.dataset[S.filter];
        S.hoseSize = null;
        if (picker) {
          picker.querySelectorAll('.ch').forEach(function(c) { c.classList.remove('sel'); });
        }
        $('co2-dg').innerHTML = '';
      } else {
        /* HOB / internal — in-tank diffusers by tank size */
        S.hoseSize = null;
        if (picker) picker.style.display = 'none';
        if (dsub && dsub.dataset[S.filter]) dsub.textContent = dsub.dataset[S.filter];
        buildProds('co2-dg', INTANK_DIFFS[S.size] || INTANK_DIFFS.medium, 'diff', 'co2-n5');
      }
    }

    /* Step 6: Hose */
    if (n === 6) {
      $('co2-n6').disabled = true;
      buildProds('co2-hg', HOSE, 'hose', 'co2-n6');
    }

    /* Step 7: Extras — re-render to include Sodastream stand if applicable */
    if (n === 7) {
      renderExtras();
    }

    window.scrollTo({ top: $('co2-ba').offsetTop - 80, behavior: 'smooth' });
  }

  /* ─────────────────────────────────────────────────────
     SELECTION HANDLERS
     ───────────────────────────────────────────────────── */
  function pick(el, k, v) {
    el.closest('.cg').querySelectorAll('.ch').forEach(function(c) { c.classList.remove('sel'); });
    el.classList.add('sel');
    S[k] = v;
    var btn = $('co2-n' + cur);
    if (btn) btn.disabled = false;

    /* Show/hide Sodastream warning for medium/large tanks */
    if (k === 'cylinder') {
      var ssWarn = $('co2-ss-warn');
      if (ssWarn) {
        ssWarn.style.display = (v === 'sodastream' && (S.size === 'medium' || S.size === 'large')) ? '' : 'none';
      }
    }

    /* Auto-advance on step 1 (tank size selection) */
    if (cur === 1) {
      setTimeout(function() { goTo(2); }, 400);
    }
  }

  function pickHoseSize(el, size) {
    el.closest('.cg').querySelectorAll('.ch').forEach(function(c) { c.classList.remove('sel'); });
    el.classList.add('sel');
    S.hoseSize = size;
    /* Build inline diffuser products for selected hose diameter */
    buildProds('co2-dg', INLINE_DIFFS[S.hoseSize] || INLINE_DIFFS['16_22'], 'diff', 'co2-n5');
  }

  function toggleX(el, idx) {
    var skipCards = document.querySelectorAll('#co2-extras-area .skip-wrap .ch');
    skipCards.forEach(function(c) { c.classList.remove('sel'); });

    el.classList.toggle('sel');
    var x = EXTRAS[idx];
    if (el.classList.contains('sel')) {
      S.extras[idx] = { name: x.name, variant: x.variant, price: x.price, vid: x.vid, img: x.img, url: x.url };
    } else {
      delete S.extras[idx];
    }
    $('co2-n7').disabled = false;
  }

  function skipX(el) {
    document.querySelectorAll('#co2-extras-area .ch').forEach(function(c) { c.classList.remove('sel'); });
    el.classList.add('sel');
    S.extras = {};
    $('co2-n7').disabled = false;
  }

  /* ─────────────────────────────────────────────────────
     DYNAMIC PRODUCT CARDS
     ───────────────────────────────────────────────────── */
  function buildProds(gid, prods, stateKey, nid) {
    var g = $(gid);
    if (!g) return;
    g.innerHTML = '';
    if (!prods || !prods.length) return;

    prods.forEach(function(p) {
      var isOOS = p.avail === false;
      var d = document.createElement('div');
      d.className = 'prd' + (isOOS ? ' oos' : '');
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', isOOS ? '-1' : '0');

      var thumb = p.img
        ? '<img src="' + p.img + '" alt="' + (p.name || '') + '" loading="lazy">'
        : '<span style="font-size:2.5rem;opacity:.4">\u2699\uFE0F</span>';

      var link = p.url
        ? '<a href="' + p.url + '" target="_blank" class="plink" onclick="event.stopPropagation()">View product \u2197</a>'
        : '';

      var variantLabel = (p.variant && p.variant !== 'Default Title') ? '<div class="pvariant">' + p.variant + '</div>' : '';

      var topBar = '';
      if (isOOS) {
        topBar = '<div class="oos-bar">Out of Stock</div>';
      } else if (p.rec) {
        topBar = '<div class="recbar">\u2B50 Recommended for your setup</div>';
      }

      d.innerHTML =
        topBar +
        '<div class="pthumb">' + thumb + '</div>' +
        '<div class="pbody">' +
          (p.brand ? '<div class="pbrand">' + p.brand + '</div>' : '') +
          '<div class="pname">' + (p.name || 'Product') + '</div>' +
          variantLabel +
          (p.why ? '<div class="pwhy">' + p.why + '</div>' : '') +
          '<div class="pprice-wrap">' +
            '<div class="pprice">$' + (p.price || 0).toFixed(2) + '</div>' +
            link +
          '</div>' +
        '</div>';

      function selectCard() {
        if (isOOS) return;
        g.querySelectorAll('.prd').forEach(function(c) { c.classList.remove('sel'); });
        d.classList.add('sel');
        S[stateKey] = p.name;
        S[stateKey + 'Variant'] = p.variant || null;
        S[stateKey + 'P'] = p.price;
        S[stateKey + 'Vid'] = p.vid;
        S[stateKey + 'Img'] = p.img || null;
        S[stateKey + 'Url'] = p.url || null;
        if (nid) $(nid).disabled = false;
      }

      d.addEventListener('click', selectCard);
      d.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(); }
      });

      g.appendChild(d);
    });
  }

  /* ─────────────────────────────────────────────────────
     EXTRAS RENDERING
     ───────────────────────────────────────────────────── */
  function toggleStand(el) {
    el.classList.toggle('sel');
    if (el.classList.contains('sel')) {
      S.ssStand = { name: SS_STAND.name, variant: SS_STAND.variant, price: SS_STAND.price, vid: SS_STAND.vid, img: SS_STAND.img, url: SS_STAND.url };
    } else {
      delete S.ssStand;
    }
    $('co2-n7').disabled = false;
  }

  function renderExtras() {
    var area = $('co2-extras-area');
    if (!area) return;
    area.innerHTML = '';

    /* Sodastream cylinder stand recommendation */
    if (S.cylinder === 'sodastream' && SS_STAND && SS_STAND.vid) {
      var standLbl = document.createElement('div');
      standLbl.className = 'optlbl';
      standLbl.innerHTML = 'Recommended for Sodastream <span class="optbadge">Highly Recommended</span>';
      area.appendChild(standLbl);

      var standGrid = document.createElement('div');
      standGrid.className = 'cg g2';

      var isStandOOS = SS_STAND.avail === false;
      var standCard = document.createElement('div');
      standCard.className = 'ch' + (isStandOOS ? ' oos' : '') + (S.ssStand ? ' sel' : '');
      standCard.setAttribute('role', 'button');
      standCard.setAttribute('tabindex', isStandOOS ? '-1' : '0');

      var standVisual = SS_STAND.img
        ? '<img class="cimg" src="' + SS_STAND.img + '" alt="" loading="lazy">'
        : '<span class="cico">\uD83E\uDDF1</span>';

      var standVariant = (SS_STAND.variant && SS_STAND.variant !== 'Default Title')
        ? '<div class="cdesc" style="color:var(--green-mid);margin-bottom:.2rem">' + SS_STAND.variant + '</div>'
        : '';

      standCard.innerHTML =
        standVisual +
        '<div class="clbl">' + SS_STAND.name + '</div>' +
        standVariant +
        '<div class="cdesc">Keeps your Sodastream cylinder upright and stable, especially when the regulator on top makes the setup top-heavy.</div>' +
        '<span class="cbadge pop">Highly Recommended</span>' +
        '<div class="x-price">$' + SS_STAND.price.toFixed(2) + '</div>';

      if (!isStandOOS) {
        standCard.addEventListener('click', function() { toggleStand(standCard); });
        standCard.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleStand(standCard); }
        });
      }
      standGrid.appendChild(standCard);
      area.appendChild(standGrid);
    }

    var lbl = document.createElement('div');
    lbl.className = 'optlbl';
    lbl.innerHTML = 'Recommended Add-ons <span class="optbadge">Optional</span>';
    area.appendChild(lbl);

    var grid = document.createElement('div');
    grid.className = 'cg g3';

    EXTRAS.forEach(function(x, i) {
      if (!x) return;
      var isOOS = x.avail === false;
      var card = document.createElement('div');
      card.className = 'ch' + (isOOS ? ' oos' : '');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', isOOS ? '-1' : '0');

      var visual = x.img
        ? '<img class="cimg" src="' + x.img + '" alt="" loading="lazy">'
        : '<span class="cico">' + (x.name.indexOf('Check Valve') >= 0 ? '\uD83D\uDEE1\uFE0F' : '\uD83D\uDFE2') + '</span>';

      var link = x.url
        ? '<a href="' + x.url + '" target="_blank" class="plink" onclick="event.stopPropagation()">View product \u2197</a>'
        : '';

      var xVariant = (x.variant && x.variant !== 'Default Title') ? '<div class="cdesc" style="color:var(--green-mid);margin-bottom:.2rem">' + x.variant + '</div>' : '';

      var badgeHtml = isOOS
        ? '<span class="cbadge pop">Out of Stock</span>'
        : (x.badge ? '<span class="cbadge pop">Highly Recommended</span>' : '');

      card.innerHTML =
        visual +
        '<div class="clbl">' + x.name + '</div>' +
        xVariant +
        '<div class="cdesc">' + (x.desc || '') + '</div>' +
        badgeHtml +
        '<div class="x-price">$' + x.price.toFixed(2) + '</div>' +
        link;

      if (!isOOS) {
        card.addEventListener('click', function() { toggleX(card, i); });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleX(card, i); }
        });
      }
      grid.appendChild(card);
    });
    area.appendChild(grid);

    var skipWrap = document.createElement('div');
    skipWrap.className = 'cg g2 skip-wrap';
    skipWrap.style.marginTop = '.8rem';
    var skipCard = document.createElement('div');
    skipCard.className = 'ch';
    skipCard.setAttribute('role', 'button');
    skipCard.setAttribute('tabindex', '0');
    skipCard.innerHTML = '<span class="cico">\u23ED\uFE0F</span><div class="clbl">Skip Extras</div><div class="cdesc">I don\'t need any extras right now</div>';
    skipCard.addEventListener('click', function() { skipX(skipCard); });
    skipCard.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); skipX(skipCard); }
    });
    skipWrap.appendChild(skipCard);
    area.appendChild(skipWrap);
  }

  /* ─────────────────────────────────────────────────────
     SUMMARY
     ───────────────────────────────────────────────────── */
  function showSum() {
    document.querySelectorAll('.co2-bb .step').forEach(function(s) { s.classList.remove('active'); });
    $('co2-ss').classList.add('active');
    $('co2-pf').style.width = '100%';
    $('co2-pl').textContent = 'Bundle Ready!';
    $('co2-pn').textContent = '';

    var rows = $('co2-brows');
    rows.innerHTML = '';
    var total = 0;
    var count = 0;

    function addRow(cat, imgSrc, name, price, opt, url, variantName) {
      if (!name) return;
      total += price;
      count++;
      var r = document.createElement('div');
      r.className = 'brow';

      var icoHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="">'
        : '\u2699\uFE0F';

      var nameHtml = url
        ? '<a href="' + url + '" target="_blank">' + name + '</a>'
        : name;

      var variantHtml = (variantName && variantName !== 'Default Title')
        ? '<div class="bvariant">' + variantName + '</div>'
        : '';

      r.innerHTML =
        '<div class="bico">' + icoHtml + '</div>' +
        '<div class="binf">' +
          '<div class="bcat">' + cat + (opt ? ' <span class="botag">\u00B7 Optional</span>' : '') + '</div>' +
          '<div class="bname">' + nameHtml + '</div>' +
          variantHtml +
        '</div>' +
        '<div class="bprice">$' + price.toFixed(2) + '</div>';
      rows.appendChild(r);
    }

    addRow('CO\u2082 Regulator', S.regImg, S.reg, S.regP, false, S.regUrl, S.regVariant);
    addRow('CO\u2082 Diffuser', S.diffImg, S.diff, S.diffP, false, S.diffUrl, S.diffVariant);

    if (S.hose) {
      addRow('CO\u2082 Tubing', S.hoseImg, S.hose, S.hoseP, false, S.hoseUrl, S.hoseVariant);
    }

    /* Sodastream adapter — auto-added, picks correct adapter based on regulator */
    if (S.cylinder === 'sodastream') {
      var adapter = getSSAdapter();
      if (adapter) {
        addRow('Sodastream Adapter', adapter.img, adapter.name, adapter.price, false, adapter.url, adapter.variant);
      }
    }

    /* Sodastream cylinder stand — optional */
    if (S.ssStand) {
      addRow('Cylinder Stand', S.ssStand.img, S.ssStand.name, S.ssStand.price, true, S.ssStand.url, S.ssStand.variant);
    }

    Object.keys(S.extras).forEach(function(k) {
      var e = S.extras[k];
      var cat = (e.name && e.name.indexOf('Check Valve') >= 0) ? 'Safety' : 'CO\u2082 Monitor';
      addRow(cat, e.img, e.name, e.price, true, e.url, e.variant);
    });

    /* Discount */
    var discountAmount = 0;
    if (DISC.type === 'percentage' && DISC.value > 0) {
      discountAmount = total * (DISC.value / 100);
    } else if (DISC.type === 'fixed' && DISC.value > 0) {
      discountAmount = Math.min(DISC.value, total);
    }

    if (discountAmount > 0) {
      var dr = document.createElement('div');
      dr.className = 'brow discount-row';
      var dlabel = DISC.label || 'Bundle Discount';
      if (DISC.type === 'percentage') dlabel += ' (' + DISC.value + '% off)';
      dr.innerHTML =
        '<div class="bico">\uD83C\uDFF7\uFE0F</div>' +
        '<div class="binf"><div class="bcat">Discount</div><div class="bname">' + dlabel + '</div></div>' +
        '<div class="bprice">-$' + discountAmount.toFixed(2) + '</div>';
      rows.appendChild(dr);
    }

    var finalTotal = total - discountAmount;

    /* Total display */
    var totEl = $('co2-btot');
    if (discountAmount > 0) {
      totEl.innerHTML = '<span class="btp-original">$' + total.toFixed(2) + '</span> $' + finalTotal.toFixed(2);
    } else {
      totEl.textContent = '$' + finalTotal.toFixed(2);
    }

    var metaText = count + ' component' + (count !== 1 ? 's' : '') + ' \u00B7 ' + (SLBLS[S.size] || '') + ' \u00B7 ' + (FLBLS[S.filter] || '');
    if (S.hoseSize && HSLBLS[S.hoseSize]) metaText += ' \u00B7 ' + HSLBLS[S.hoseSize] + ' hose';
    $('co2-bmeta').textContent = metaText;
    $('co2-sumP').textContent = 'Matched to your ' + (SLBLS[S.size] || '').toLowerCase() + ' tank with a ' + (FLBLS[S.filter] || '').toLowerCase() + '.';
    $('co2-ct').textContent = 'All selected components are compatible with each other and optimised for your ' + (SLBLS[S.size] || '').toLowerCase() + ' tank running a ' + (FLBLS[S.filter] || '').toLowerCase() + '.';

    window.scrollTo({ top: $('co2-ba').offsetTop - 80, behavior: 'smooth' });
  }

  /* ─────────────────────────────────────────────────────
     ADD TO CART (Shopify Cart API)
     ───────────────────────────────────────────────────── */
  function addToCart() {
    var items = [];

    if (S.regVid)  items.push({ id: S.regVid, quantity: 1 });
    if (S.diffVid) items.push({ id: S.diffVid, quantity: 1 });
    if (S.hoseVid) items.push({ id: S.hoseVid, quantity: 1 });

    /* Sodastream adapter — picks correct one based on regulator */
    if (S.cylinder === 'sodastream') {
      var adapter = getSSAdapter();
      if (adapter && adapter.vid) {
        items.push({ id: adapter.vid, quantity: 1 });
      }
    }

    /* Sodastream cylinder stand */
    if (S.ssStand && S.ssStand.vid) {
      items.push({ id: S.ssStand.vid, quantity: 1 });
    }

    Object.keys(S.extras).forEach(function(k) {
      if (S.extras[k].vid) items.push({ id: S.extras[k].vid, quantity: 1 });
    });

    if (items.length === 0) {
      alert('Please complete all steps before adding to cart.');
      return;
    }

    var btn = $('co2-add-btn');
    btn.disabled = true;
    btn.textContent = 'Adding to cart\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw err; });
      return response.json();
    })
    .then(function() {
      btn.textContent = '\u2705 Added! Redirecting\u2026';
      if (DISC.code) {
        fetch('/discount/' + encodeURIComponent(DISC.code));
      }
      setTimeout(function() { window.location.href = '/cart'; }, 800);
    })
    .catch(function(err) {
      btn.disabled = false;
      btn.textContent = '\uD83D\uDED2 Add All to Cart';
      var msg = (err && err.description) || 'Something went wrong adding to cart. Please try again.';
      alert(msg);
    });
  }

  /* ─────────────────────────────────────────────────────
     RESTART
     ───────────────────────────────────────────────────── */
  function restart() {
    S.size = null; S.cylinder = null; S.filter = null; S.hoseSize = null;
    S.reg = null;  S.regP = 0;  S.regVid = null;  S.regImg = null;  S.regUrl = null;
    S.diff = null; S.diffP = 0; S.diffVid = null; S.diffImg = null; S.diffUrl = null;
    S.hose = null; S.hoseP = 0; S.hoseVid = null; S.hoseImg = null; S.hoseUrl = null;
    S.extras = {};
    delete S.ssStand;

    document.querySelectorAll('.co2-bb .ch, .co2-bb .prd')
      .forEach(function(e) { e.classList.remove('sel'); });
    document.querySelectorAll('.co2-bb .bfwd')
      .forEach(function(b) { b.disabled = true; });

    var picker = $('co2-hose-picker');
    if (picker) picker.style.display = 'none';

    var ssWarn = $('co2-ss-warn');
    if (ssWarn) ssWarn.style.display = 'none';

    var addBtn = $('co2-add-btn');
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = '\uD83D\uDED2 Add All to Cart';
    }

    renderExtras();
    goTo(1);
  }

  /* ─────────────────────────────────────────────────────
     INIT
     ───────────────────────────────────────────────────── */
  function init() {
    renderExtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ─────────────────────────────────────────────────────
     PUBLIC API
     ───────────────────────────────────────────────────── */
  window.CO2Builder = {
    start: start,
    goTo: goTo,
    pick: pick,
    pickHoseSize: pickHoseSize,
    toggleX: toggleX,
    skipX: skipX,
    showSum: showSum,
    addToCart: addToCart,
    restart: restart
  };

})();
